import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Route, Switch } from 'react-router';
import { withRouter } from 'react-router-dom';

import PaymentMethods from 'containers/payment-methods';
import EditPaymentMethod from 'containers/payment-methods/edit';
import NewPaymentMethod from 'containers/payment-methods/new';
import EditBusinessProfile from 'containers/payment-methods/business-profiles/edit';
import NewBusinessProfile from 'containers/payment-methods/business-profiles/new';
import ConnectBusinessProfile from 'containers/payment-methods/business-profiles/connect';

import getPaymentMethodsCreator from 'action-creators/payment-methods/get-payment-methods';
import selectPaymentMethodCreator from 'action-creators/payment-methods/select-payment-method';
import initializeNewPaymentMethodCreator from 'action-creators/payment-methods/initialize-new-payment-method';
import initializeNewBusinessProfileCreator from 'action-creators/payment-methods/initialize-new-business-profile';
import initializeBusinessProfileConnectCreator from 'action-creators/payment-methods/initialize-business-profile-connect';

import Brand from 'models/brand';

const propTypes = {
  initializeNewPaymentMethod: PropTypes.func.isRequired,
  initializeNewBusinessProfile: PropTypes.func.isRequired,
  initializeBusinessProfileConnect: PropTypes.func.isRequired,
  selectPaymentMethod: PropTypes.func.isRequired,
  brand: PropTypes.instanceOf(Brand).isRequired,
};

const PaymentMethodsWrapper = ({
  initializeNewPaymentMethod,
  initializeNewBusinessProfile,
  initializeBusinessProfileConnect,
  selectPaymentMethod,
  brand,
}) => (
  <div className="payment-methods">
    <Switch>
      <Route
        path="/account/payment-methods/new"
        render={() => {
          initializeNewPaymentMethod();
          return <NewPaymentMethod brand={brand} />;
        }}
      />
      <Route
        path="/account/payment-methods/business-profiles/new/connect"
        render={() => {
          initializeBusinessProfileConnect();
          return <ConnectBusinessProfile timelineType="create" brand={brand} />;
        }}
      />
      <Route
        path="/account/payment-methods/business-profiles/new"
        render={() => {
          initializeNewBusinessProfile();
          return <NewBusinessProfile brand={brand} />;
        }}
      />
      <Route
        path="/account/payment-methods/business-profiles/:paymentMethodId/connect"
        render={() => {
          initializeBusinessProfileConnect();
          return <ConnectBusinessProfile timelineType="edit" brand={brand} />;
        }}
      />
      <Route
        path="/account/payment-methods/business-profiles/:paymentMethodId"
        render={({ match }) => {
          selectPaymentMethod(match.params);
          return <EditBusinessProfile brand={brand} />;
        }}
      />
      <Route
        path="/account/payment-methods/:paymentMethodId"
        render={({ match }) => {
          selectPaymentMethod(match.params);
          return <EditPaymentMethod brand={brand} />;
        }}
      />
      <Route
        path="/account/payment-methods"
        render={() => <PaymentMethods brand={brand} />}
      />
    </Switch>
  </div>
);

const mapDispatchToProps = dispatch => (
  bindActionCreators({
    getPaymentMethods: getPaymentMethodsCreator,
    selectPaymentMethod: selectPaymentMethodCreator,
    initializeNewPaymentMethod: initializeNewPaymentMethodCreator,
    initializeNewBusinessProfile: initializeNewBusinessProfileCreator,
    initializeBusinessProfileConnect: initializeBusinessProfileConnectCreator,
  }, dispatch)
);

const mapStateToProps = (state) => {
  const { brand } = state.brand;

  return {
    brand,
  };
};

PaymentMethodsWrapper.propTypes = propTypes;
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(PaymentMethodsWrapper));
